import { memo } from 'react';
import { Tag } from '@scale/scaleui';
import apiFetch from 'react-scale/lib/api-fetch';
import { useQuery } from 'react-query';

interface SandboxProjectTagProps {
  projectId?: string;
}

function SandboxProjectTag(props: SandboxProjectTagProps) {
  const {
    data: isSandboxProject,
    isLoading: loadingIsSandboxProject,
    error: errorIsSandboxProject,
  } = useQuery(['isSandboxProject', props.projectId], async () => {
    if (props.projectId) {
      const data = await apiFetch(null, `internal/scaler/isSandboxProject`, {
        query: {
          projectId: props.projectId,
        },
      });
      return data?.isSandboxProject;
    } else {
      return false;
    }
  });

  if (loadingIsSandboxProject || !isSandboxProject || errorIsSandboxProject) return null;

  return (
    <Tag title="This is a Test Sandbox Project" variant="danger">
      Test Sandbox Project, no payment will be made.
    </Tag>
  );
}

export default memo(SandboxProjectTag);
